import $ from 'jquery';

export default class SimpleDropzone {
	init() {
		$('.dropzone').each(function () {
			const $dropzone = $(this);
			const $fileListDescription = $dropzone.next('.help-block');
			const $originalDescription = `<div class="original-description">${$fileListDescription.html()}</div>`;
			$fileListDescription.html($originalDescription);

			$(this).on('dragover', function () {
				$(this).addClass('hover');
			});

			$(this).on('dragleave', function () {
				$(this).removeClass('hover');
			});

			$(this).on('drop', function () {
				$(this).removeClass('hover');
			});

			function initInputs($inputs) {
				$inputs.on('change', (e) => {
					const $input = $(e.target);
					if ($input.attr('name').includes('[]')) {
						//Clone the input
						const $cloneInput = $input.clone();
						$cloneInput
							.attr('id', `fileuploadmultiple-${getNextMultiFileUploadId()}`)
							.val('');
						$input.after($cloneInput);
						$input.hide();

						//Init newly created input
						initInputs($cloneInput);
					}
					//Add the file to the list
					const filesAsString = Object.keys($input[0].files)
						.map((x) => $input[0].files[x].name)
						.join(', ');
					$fileListDescription.append(
						`<div class="file-list-item"><span class="file-list-item-name">${filesAsString}</span><div class="remove-btn" id="${$input.attr('id')}-remove" title="Entfernen"></div></div>`,
					);

					if ($fileListDescription.find('.file-list-item').length) {
						$fileListDescription.find('.original-description').hide();
					}

					$(`#${$input.attr('id')}-remove`).click(function () {
						if ($input.attr('name').includes('[]')) {
							$input.remove();
						}
						$(this).parent().remove();
						if (!$fileListDescription.find('.file-list-item').length) {
							$fileListDescription.find('.original-description').show();
						}
					});
					if ($input.attr('name').includes('[]')) {
					}
				});
			}

			initInputs($dropzone.find('input[type=file]'));
		});

		function getNextMultiFileUploadId() {
			let id = 0;
			$('.dropzone')
				.find('input')
				.each(function () {
					const currentId = Number.parseInt(
						$(this).attr('id').replace('fileuploadmultiple-', ''),
					);
					if (currentId > id) {
						id = currentId;
					}
				});
			return id + 1;
		}
	}
}
